export var check="https://traza-brio.com/calidad/ws/upload/mark.png";
export var cancel="https://traza-brio.com/calidad/ws/upload/cancel.png";
export var logo="https://traza-brio.com/calidad/ws/upload/Logo Brio.png";